import { Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SAUTableModule } from '@some-angular-utils/table';
import { Urls } from '@/apiConnection/urls';
import { SAUModalService } from '@some-angular-utils/modal';
import { CustomDeleteComponent } from '@/components/custom-delete/custom-delete.component';
import { AddButtonComponent } from '@/components/add-button/add-button.component';

@Component({
  imports: [
    RouterModule,
    SAUTableModule,
    AddButtonComponent,
  ],
  templateUrl: './inventory-history-list.page.html',
  styleUrl: './inventory-history-list.page.scss',
  encapsulation: ViewEncapsulation.None
})
export class InventoryHistoryListPage {

  @ViewChild('sauTable')
  sauTable: { refresh: () => void; getItems: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);

  public url = Urls.urls.historyInventory;

  public headers = [
    { name: 'Fecha', key: 'date', type: 'dateTime' },
    { name: 'Oficina', key: 'office.name' },
    { name: 'Productos contados', key: 'details_count' },
  ];

  constructor(private router: Router) { }

  toggleViewForm(item: { id: number } = { id: 0 }) {
    this.router.navigate(['/inventory-history/view', item.id]);
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'historial de inventario';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

}
